export const NodeType = {
  ASSET: "ASSET",
  SYSTEM: "SYSTEM",
  SUBSYSTEM: "SUBSYSTEM",
  EQUIPMENT: "EQUIPMENT",
  REQUIREMENT: "REQUIREMENT",
  DISCIPLINE: "DISCIPLINE",
  DOCUMENT: "DOCUMENT",
  COMPONENT: "COMPONENT",
  SENSOR: "SENSOR"
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type NodeType = (typeof NodeType)[keyof typeof NodeType] | string;

export const RelationshipType = {
  CONTAINS: "CONTAINS",
  OWNED_BY: "OWNED_BY",
  HAS: "HAS",
  CONSTRAINT: "CONSTRAINT",
  HAS_COMPONENT: "HAS_COMPONENT",
  HAS_REQUIREMENT: "HAS_REQUIREMENT",
  SOURCED_FROM: "SOURCED_FROM",
  MONITORED_BY: "MONITORED_BY"
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type RelationshipType =
  | (typeof RelationshipType)[keyof typeof RelationshipType]
  | string;

export type GraphNode = {
  id: string;
  label: string;
  type: NodeType;
  x: number;
  y: number;
  propsCount?: number;
};

export type GraphEdge = {
  id: string;
  source: string;
  target: string;
  relationship: RelationshipType;
};

export type NodeProperties = Record<string, string>;

export type ConnectedEntity = {
  id: string;
  name: string;
  category: string;
  relationship: RelationshipType;
  type: NodeType;
};

export type KnowledgeGraphData = {
  nodes: GraphNode[];
  edges: GraphEdge[];
  properties: NodeProperties;
  connectedEntities: ConnectedEntity[];
};
